module.exports = __webpack_public_path__ + "img/疏导点.e8796abe.png";